import React from "react";
import {MenuItem, TextField} from "@mui/material";
import {LookupResult} from "../types/lookup_types";

export interface TranslationsDropdownViewProps {
    lookupResults: LookupResult[];
    selectedIndex: number;
    onSelectedIndexChange: (index: number) => void;
}

export default function TranslationsDropdownView({lookupResults, selectedIndex, onSelectedIndexChange}: TranslationsDropdownViewProps) {

    return (
        <TextField
            select={true}
            variant="outlined"
            fullWidth={true}
            size="small"
            label="Translations"
            value={selectedIndex}
            onChange={(e) => onSelectedIndexChange(Number(e.target.value))}
        >
            {lookupResults.map((result, index) => (
                <MenuItem key={index} value={index}>
                    {result.translations.join(", ")}
                </MenuItem>
            ))}
        </TextField>
    );
}
